export default __webpack_public_path__ + "static/fantastico-1793d717f0264c9239ba518e5cb50ae9.png";